import { Link } from "react-router-dom";
import { Confetti, ArrowRight } from "@phosphor-icons/react";

export default function ExhibitionCard({ week }) {
  const bg =
    "https://static.prod-images.emergentagent.com/jobs/2d9c142e-ed55-40de-ac53-c13d9c2402dc/images/9cae6c145cf35eb03589857223709343327960b4a7a2a81e3ce919f4996d21d7.png";
  return (
    <div
      className="relative rounded-3xl overflow-hidden border border-amber-200 shadow-sm"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(255,237,213,0.92), rgba(254,202,202,0.85)), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="exhibition-card"
    >
      <div className="p-6 sm:p-8">
        <div className="flex items-center gap-2 mb-3">
          <Confetti weight="fill" className="text-pink-500" size={22} />
          <span className="text-[11px] font-bold tracking-wider uppercase text-pink-700 bg-white/70 px-2 py-1 rounded-full">
            Final Showcase · Week 10
          </span>
        </div>
        <h2 className="font-outfit text-3xl sm:text-4xl font-black tracking-tight text-slate-900 max-w-md">
          Exhibition Day
        </h2>
        <p className="font-caveat text-2xl text-pink-700 mt-1">Show the world what you built.</p>
        <p className="mt-3 text-slate-700 max-w-lg text-sm">
          Parents, headteacher, and friends rotate through your AI stations. Demo, explain, celebrate — and earn your
          Certificate of Completion.
        </p>
        <Link
          to={`/week/10`}
          data-testid="exhibition-open-link"
          className="btn-tactile-white mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white text-slate-900 font-outfit font-bold hover:bg-slate-50 border border-slate-200"
        >
          See the plan <ArrowRight weight="bold" size={16} />
        </Link>
      </div>
    </div>
  );
}
